import { render, staticRenderFns } from "./ExcluorButton.vue?vue&type=template&id=8e863fde&scoped=true"
import script from "./ExcluorButton.vue?vue&type=script&lang=js"
export * from "./ExcluorButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e863fde",
  null
  
)

export default component.exports